//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TabularRow',
  props: {
    level: { type: Number, default: 0 },
    value: { type: [Array, Object], default: () => [] },
    columns: { type: Array, default: () => [] },
    hasScroll: { type: Boolean, default: false },
    maxWidth: { type: Number, default: 0 },
  },
  methods: {
    getDisplayValue(column, value) {
      const display = value?.display;
      return display;
    },
    getColumnWidth(column) {
      return column.width ? { flex: `0 0 ${column.width}` } : {};
    },
  },
};
